import { html, css, LitElement } from 'lit-element';

export class AnalogClock extends LitElement {
  static get styles() {
    return css`
      svg {
        display: block;
        margin: auto;
      }
    `;
  }

  static get properties() {
    return {
      hours: {
        type: Number,
      },
      minutes: {
        type: Number,
      },
    };
  }

  updated() {
    this._drawClock();
  }

  render() {
    return html`
      <!--
        station-clock.svg

      Copyright (c) 2012 Rüdiger Appel
      Licensed under the creative common license.

        Date:    2012-03-23
      Version: 1.0
      Email:   ludi(at)me(dot)com
      Home:    http://www.3Quarks.com/
        -->
      <svg id="content"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xmlns:ev="http://www.w3.org/2001/xml-events"
          version="1.1"
          baseProfile="full"
          width="80%"
          height="80%"
          viewBox="0 0 200 200"
        >
          <defs>
            <!-- hour stroke (DIN 41091.4) -->
            <symbol id="hourStrokeDIN41091.4">
              <rect x="97" y="0" width="6" height="7" />
            </symbol>

            <!-- minute stroke (DIN 41091.4) -->
            <symbol id="minuteStrokeDIN41091.4">
              <rect x="98.75" y="0" width="2.5" height="7" />
            </symbol>

            <!-- five minutes strokes (DIN 41091.4) -->
            <symbol id="fiveMinutesStrokesDIN41091.4">
              <use xlink:href="#hourStrokeDIN41091.4" />
              <use xlink:href="#minuteStrokeDIN41091.4" transform="rotate( 6, 100, 100)" />
              <use xlink:href="#minuteStrokeDIN41091.4" transform="rotate(12, 100, 100)" />
              <use xlink:href="#minuteStrokeDIN41091.4" transform="rotate(18, 100, 100)" />
              <use xlink:href="#minuteStrokeDIN41091.4" transform="rotate(24, 100, 100)" />
            </symbol>

            <!-- quarter strokes (DIN 41091.4) -->
            <symbol id="quarterStrokesDIN41091.4">
              <use xlink:href="#fiveMinutesStrokesDIN41091.4" />
              <use xlink:href="#fiveMinutesStrokesDIN41091.4" transform="rotate(30, 100, 100)" />
              <use xlink:href="#fiveMinutesStrokesDIN41091.4" transform="rotate(60, 100, 100)" />
            </symbol>

            <!-- visible dial circle -->
            <clipPath id="dialCircle">
              <circle cx="100" cy="100" r="100" />
            </clipPath>
          </defs>

          <!-- clock -->
          <g id="clock" clip-path="url(#dialCircle)">
            <!-- background -->
            <g id="background" style="fill:none">
              <circle cx="100" cy="100" r="100" style="stroke:none" />
            </g>

            <!-- dial -->
            <g id="dial" style="fill:#333">
              <g id="dialDIN41091.4">
                <use xlink:href="#quarterStrokesDIN41091.4" style="stroke:none" />
                <use
                  xlink:href="#quarterStrokesDIN41091.4"
                  style="stroke:none"
                  transform="rotate( 90, 100, 100)"
                />
                <use
                  xlink:href="#quarterStrokesDIN41091.4"
                  style="stroke:none"
                  transform="rotate(180, 100, 100)"
                />
                <use
                  xlink:href="#quarterStrokesDIN41091.4"
                  style="stroke:none"
                  transform="rotate(270, 100, 100)"
                />
                <g
                  text-anchor="middle"
                  letter-spacing="-2"
                  font-family="sans-serif"
                  font-size="24px"
                  style="stroke:none"
                >
                  <text x="100" y="30">12</text>
                  <text x="143" y="41">1</text>
                  <text x="171" y="70">2</text>
                  <text x="182" y="109">3</text>
                  <text x="171" y="147">4</text>
                  <text x="142" y="176">5</text>
                  <text x="100" y="188">6</text>
                  <text x="60" y="176">7</text>
                  <text x="30" y="147">8</text>
                  <text x="18" y="109">9</text>
                  <text x="34" y="70">10</text>
                  <text x="61" y="41">11</text>
                </g>
              </g>
            </g>

            <!-- hour hand -->
            <g id="hourHand" style="fill:#222">
              <g id="hourHandSwiss">
                <polygon points="95,33 105,33 106,125 94,125" style="stroke:none" />
              </g>
            </g>

            <!-- minute hand -->
            <g id="minuteHand" style="fill:#222">
              <g id="minuteHandSwiss">
                <polygon points="96,5 104,5 105,125 95,125" style="stroke:none" />
              </g>
            </g>

            <!-- axis cover -->
            <g id="axisCover" style="fill:none">
              <circle id="axisCoverCircle" cx="100" cy="100" r="10" style="stroke:none" />
            </g>
          </g>
        </svg>
      </div>
    `;
  }

  _drawClock() {
    const now =
      this.hours || this.minutes ? new Date(2016, 1, 1, this.hours, this.minutes, 0) : new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();

    // rotate hour hands
    this._rotateElement('hourHand', 30 * hours + 0.5 * minutes);

    // rotate minute hand
    this._rotateElement(
      'minuteHand',
      6 * minutes,
    );
  }

  _rotateElement(id, angle) {
    const el = this.shadowRoot.getElementById(id);
    el.setAttribute('transform', `rotate(${angle}, 100, 100)`);
  }

}
